import React, { useEffect, useRef, useState } from "react";
import { Editor, EditorState, RichUtils, convertToRaw } from "draft-js";
import "./RichTextEditor.css";
import { Tag } from "antd";

const RichTextEditor = (props) => {
  const [editorState, setEditorState] = useState(() => EditorState.createEmpty());
  const editor = useRef(null);

  const { setEmailForm, form } = props;

  const focusEditor = () => {
    if (editor.current) {
      editor.current.focus();
    }
  };

  // Update rawState whenever editorState changes
  useEffect(() => {
    const content = editorState.getCurrentContent();
    setEmailForm(convertToRaw(content));
    form.setFieldsValue({
      emailTemplate: convertToRaw(content),
    });
  }, [editorState]);

  const handleKeyCommand = (command, editorState) => {
    const newState = RichUtils.handleKeyCommand(editorState, command);
    if (newState) {
      setEditorState(newState);
      return "handled";
    }
    return "not-handled";
  };

  const toggleInlineStyle = (inlineStyle) => {
    const newState = RichUtils.toggleInlineStyle(editorState, inlineStyle);
    setEditorState(newState);
  };

  const toggleBlockType = (blockType) => {
    const newState = RichUtils.toggleBlockType(editorState, blockType);
    setEditorState(newState);
  };

  return (
    <div>
      <Tag onClick={() => toggleInlineStyle("BOLD")}>Bold</Tag>
      <Tag onClick={() => toggleInlineStyle("ITALIC")}>Italic</Tag>
      <Tag onClick={() => toggleInlineStyle("UNDERLINE")}>Underline</Tag>
      <Tag onClick={() => toggleBlockType("header-one")}>H1</Tag>
      <Tag onClick={() => toggleBlockType("header-two")}>H2</Tag>
      <div className="editor-box" onClick={focusEditor}>
        <Editor editorState={editorState} handleKeyCommand={handleKeyCommand} onChange={setEditorState} ref={editor} />
      </div>
    </div>
  );
};

export default RichTextEditor;
